<ng-container *ngIf="!everythingIsOK()">
    <span class="error" *ngIf="isOffline()"> {{ 'net_status.connection_lost' | translate }}</span>
    <span class="error" *ngIf="!isOffline() && sipDisconnected()"> {{ 'net_status.sip_disconnected' | translate }}</span>
</ng-container>
